<template>
    <div>
        <swiper
            ref="busSwiper"
            class="business"
            :options="busOpt"
            @slideChange="setIndex"
        >
            <swiper-slide
                class="business__slide"
                v-for="slide in slidesBus"
                :key="slide.name"
            >
                <div class="business__wrap">
                    <div class="business__wrap-left">
                        <h1 class="business__title">
                            {{ slide.name }}

                        </h1>
                        <p>{{ slide.description }}</p>
                        <div
                            class="swiper-pagination business__pagination"
                            :class="selectColor"
                        ></div>
                    </div>
                    <div class="business__pic">
                        <svg-icon :name="slide.pathTop" :title="slide.name" />
                    </div>
                </div>
                <div class="business__legs">
                    <svg-icon :name="slide.pathBot" :title="slide.name" />
                </div>
            </swiper-slide>
        </swiper>
        <div class="business__nav">
            <div id="business-prev" class="swiper-button-prev" slot="button-prev"></div>
            <div id="business-next" class="swiper-button-next" slot="button-next"></div>
        </div>
    </div>
</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import SvgIcon from '../SvgIcon'

export default {
name: "BusinessBlock",
    data: () => ({
        slidesBus: [
            {
                name: 'Создайте профиль',
                description: 'Для спецпроектов и индивидуальных интеграций свяжитесь с нами. Мы готовы реализовать абсолютно любую идею!',
                className: 'first',
                pathTop: 'bs-1',
                pathBot: 'vsb-1'
            },
            {
                name: 'Выберите проект',
                description: 'Выберите те проекты и животных, которым хотите помочь вместе со своими сотрудниками.',
                className: 'second',
                pathTop: 'bs-2',
                pathBot: 'vsb-2'
            },
            {
                name: 'Депозит',
                description: 'Внесите депозит и прозрачно распределите помощь среди животных и проектов.',
                className: 'third',
                pathTop: 'bs-3',
                pathBot: 'vsb-3'
            },
            {
                name: 'Быстро, прозрачно и публично',
                description: 'Вся оказанная помощь отобразится в профилях животных, проектов, волонтеров.',
                className: 'four',
                pathTop: 'bs-4',
                pathBot: 'vsb-4'
            },
            {
                name: 'Контроль',
                description: 'Мы проконтролируем расход средств и предоставим личные и публичные отчеты о вашей помощи.',
                className: 'five',
                pathTop: 'bs-5',
                pathBot: 'vsb-5'
            }
        ],
        selectColor: 'first',
        busOpt: {
            slidesPerView: 1,
            spaceBetween: 10,
            speed: 800,
            observer: true,
            observeParents: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: false
            },
            navigation: {
                nextEl: '#business-next',
                prevEl: '#business-prev'
            }
        }
    }),
    components: { Swiper, SwiperSlide, SvgIcon },
    computed: {
        swiper() {
            return this.$refs.busSwiper.$swiper
        }
    },

    mounted(){
    },
    methods: {
        setIndex() {
            this.slidesBus.forEach((el, idx) => {
                if (idx === this.swiper.activeIndex) {
                    this.selectColor = el.className
                }
            })

        }
    }
}
</script>

<style lang="scss">
.business {
    margin: 10px auto;
    margin-bottom: 0;
    &__wrap {
        position: relative;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding: 10px;
        max-width: 900px;
        margin: 0 auto;
        &-left{
            padding-right: 15px;
            max-width: 450px;
        }
    }
    &__title {
        font-family: 'Comfortaa', sans-serif;
        font-size: 24px;
        line-height: 32px;
        color: #333333;

    }
    &__pic {
        width: 368px;
        height: 216px;
        background: #ffffff;
        //box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
        border-radius: 3px;
        .svg-icon {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    &__pagination {
        position: static;
        width: 288px;
        border-radius: 5px;
        height: 3px;
        display: flex;
        .swiper-pagination-bullet {
            width: 20%;
            height: 3px;
            display: inline-block;
            background: transparent;
            opacity: 1;
            outline: none;
            border-radius: 5px;
            transition: background 0.3s linear;
            &-active {
                opacity: 1;
            }
        }
        &.first {
            background: #fef1f1;
            .swiper-pagination-bullet {
                &-active {
                    background: #ee7372;
                }
            }
        }
        &.second {
            background: #fef9ec;
            .swiper-pagination-bullet {
                &-active {
                    background: #f6c143;
                }
            }
        }
        &.third {
            background: #f4fbf0;
            .swiper-pagination-bullet {
                &-active {
                    background: #91da66;
                }
            }
        }
        &.four {
            background: #eaf1fc;
            .swiper-pagination-bullet {
                &-active {
                    background: #2e76e4;
                }
            }
        }
        &.five {
            background: #f1eef9;
            .swiper-pagination-bullet {
                &-active {
                    background: #6c4dbb;
                }
            }
        }
    }
    &__legs {
        margin-top: 85px;
        .svg-icon {
            max-width: 847px;
            width: 100%;
            min-height: 175px;
            margin: 0 auto;
        }

    }
    &__nav {
        display: flex;
        justify-content: center;
        margin-top: -4px;
        background: #eaf1fc;
        padding-top: 30px;
        .swiper-button-prev,
        .swiper-button-next {
            position: static;
            outline: none;
            background: #fff;
            border-radius: 20px;
            padding: 15px 20px;
            width: auto;
            height: auto;
            margin: 0 5px;
        }
        .swiper-button-prev {
            &::after {
                content: '';
                background: url('/assets/images/arrow-r.svg') no-repeat center;
                background-size: cover;
                width: 15px;
                height: 10px;
                transform: rotate(-180deg);
            }
        }
        .swiper-button-next {
            &::after {
                content: '';
                background: url('/assets/images/arrow-r.svg') no-repeat center;
                background-size: cover;
                width: 15px;
                height: 10px;
            }
        }
    }
}
@media (max-width: 768px) {
    .business {
        &__wrap {
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &-left{
                width: 100%;
                padding-right: 0;
            }
        }
        .swiper-pagination {
            position: static;
            margin: 40px 0;
        }
        &__slide {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 600px !important;
        }
        &__nav {
            margin-top: 0;
        }
        &__legs {
            margin-top: 15px;
            //margin-bottom: -15px;
            .svg-icon {
                max-width: 100%;
                width: 100%;
                //height: 120px;
                min-height: auto;
            }
        }
    }
}

@media (max-width: 768px){
    .business__pagination{
        width: 100%;
    }
    .business__pagination .swiper-pagination-bullet{
        width: 20%;
    }
}

@media (max-width: 600px){
    .business__wrap{
        width: 100%;
    }

    .business__pic .svg-icon img{
        width: 100%;
    }
}

@media (max-width: 576px) {
    .business {
        &__slide {
            //height: 500px !important;
        }
        &__pic {
            width: 100%;
            height: 100%;
        }
        &__legs {
            //.svg-icon {
            //  height: 92px;
            //}
        }
    }
}
</style>
